var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevokeUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31944 0C4.64342 0 3.03605 0.665797 1.85092 1.85092C0.665797 3.03605 0 4.64342 0 6.31944C0 7.99547 0.665797 9.60284 1.85092 10.788C3.03605 11.9731 4.64342 12.6389 6.31944 12.6389C7.99547 12.6389 9.60284 11.9731 10.788 10.788C11.9731 9.60284 12.6389 7.99547 12.6389 6.31944C12.6389 4.64342 11.9731 3.03605 10.788 1.85092C9.60284 0.665797 7.99547 0 6.31944 0ZM2.70833 5.86806V6.77083H9.93056V5.86806H2.70833Z",
    fill: "#F01919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokeUser);
export default __webpack_public_path__ + "static/media/RevokeUser.06c76b08d5548ccbf8014fb9c876e929.svg";
export { ForwardRef as ReactComponent };